import React from "react";

import {
  AddIcon,
  DocumentIcon,
  EditIcon,
  InfoOutlinedIcon,
  InvoiceIcon,
  LinkOffIcon,
  RemoveIcon,
} from "../../../components/common/iconography";
import { Typography } from "@material-ui/core";

const toSource = function (parent, child) {
  var str = "";

  for (var c in parent) {
    if (c === "obj") {
      str += toSource(parent[c]);
    } else if (!parent[c]) {
      str += (child ? `${child}.${c}: ` : `${c}: `) + '"" </br>';
    } else if (typeof parent[c] === "string") {
      str += (child ? `${child}.${c}: ` : `${c}: `) + parent[c] + " </br>";
    } else if (typeof parent[c] === "number") {
      str += (child ? `${child}.${c}: ` : `${c}: `) + parent[c] + " </br>";
    } else if (typeof parent[c] === "boolean") {
      str += (child ? `${child}.${c}: ` : `${c}: `) + parent[c] + " </br>";
    } else if (Array.isArray(parent[c])) {
      for (let i = 0; i < parent[c].length; i++) {
        const itm = parent[c][i];
        str += toSource(itm, `${c}[${i}]`);
      }
    } else {
      if (child) str += toSource(parent[c], `${child}.${c}`);
      else str += toSource(parent[c], c);
    }
  }

  return str;
};

export const DocData = (obj) => {
  const source = toSource(obj);
  const values = source.split("</br>");
  return (
    <>
      {" "}
      {values.map((val) => (
        <Typography> {val} </Typography>
      ))}
    </>
  );
};

export const OutboundSetupHelpCreate = ({ classes }) => (
  <>
    <Typography variant="overline">
      <strong>Outbound Setup</strong>
    </Typography>
    <ul>
      <li>
        <Typography>
          <strong>Account: </strong>
          Account must be selected first to enable editing of Pick List.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>PO Number: </strong>
          Purchase Order number provided by Customer.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Carrier Name: </strong>
          Rail line / truck line name.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Carrier Type: </strong>
          Select carrier type - determines "Pickup Number" or "Railcar Number".
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Pickup Number: </strong> Required if Carrier Type = "Truck".
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Railcar Number: </strong>
          Required if shipping by Rail and Carrier Type = "Rail".
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Must Tarp: </strong>
          Required if Carrier Type = "Truck". Indicate if load needs to be
          covered with tarp.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Destination Name & Address: </strong>
          Optional - can be left blank for "Blind Shipments". If Destination
          entered, address is required.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>PO File: </strong>
          Attach the original PO from customer.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Photos: </strong>
          Attach Photos if documenting a prior shipment an have available
          photos. Only used for past shipments where photos are available.
        </Typography>
      </li>
      <li>
        <Typography variant="overline">
          <strong>Custom Fields</strong>
        </Typography>
        <Typography>
          User-defined in Account setup. These fields are Account-specific, so
          they may differ from one inbound to another.
        </Typography>
      </li>
    </ul>
  </>
);
export const OutboundPickListHelpCreate = ({ classes }) => (
  <>
    <Typography variant="overline">
      <strong>Pick List</strong>
    </Typography>
    <ul>
      <li>
        <Typography>
          <strong>Product Name: </strong>
          Product name as displayed in the Inventories. Items linked to Product
          Catalog will have an <InfoOutlinedIcon
            className={classes.icon}
          />{" "}
          Info Bubble in the right corner. Those not linked to a Product, will
          display <LinkOffIcon className={classes.icon} /> broken link icon.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Qty. On Hand: </strong>Stock quantity in storage.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Qty. Committed: </strong>
          Stock quantity Reserved across all Outbound Shipments, including this
          one - dynamically updated.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Qty. Available: </strong>
          Stock quantity available of Outbound Shipment, inclusive of Qty.
          Committed in this shipment.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Qty. Outbound: </strong>Stock quantity Reserved for this
          shipment.
        </Typography>
      </li>
      <li>
        <Typography variant="overline">
          <strong>Custom Fields</strong>
        </Typography>
        <Typography>
          User-defined in Account setup or Product Catalog. These fields are
          Account- and Product-specific, so they may differ from one inbound to
          another.
        </Typography>
      </li>
      <li>
        <Typography>
          <AddIcon className={classes.icon} />
          <strong> ADD: </strong>
          Add new Line Item to Pick List. Launches "Inventory Search" dialog.
          Account must be selected on Shipment Setup Tab to enable the Add
          button. Inventory Search dialog allows you to search for All
          Inventories by hitting the Search button, or narrowing down results by
          product name, or lot number.
        </Typography>
      </li>
      <li>
        <Typography>
          <RemoveIcon className={classes.icon} />
          <strong> REMOVE: </strong>
          Remove selected Pick List Line Item and adjust global Inventory
          counts.
        </Typography>
      </li>
      <li>
        <Typography gutterBottom>
          <strong>Total Quantity & Shipping Units: </strong>
          Sum total of Qty. Outbound. Indicate units of measure for counting Qty
          shipped.
        </Typography>
      </li>
      <li>
        <Typography gutterBottom>
          <strong>Bill Quantity & Units: </strong>
          Total Qty. Outbound and Units used for invoicing customer. If Billing
          Units = Weight Units, the measured truck weight will be used for
          invoicing.
        </Typography>
      </li>
    </ul>
  </>
);
export const OutboundNotesHelpCreate = ({ classes }) => (
  <>
    <Typography variant="overline">
      <strong>Notes</strong>
    </Typography>
    <Typography variant="subtitle1">
      Use the Notes Tab to document key events and changes made to the Shipment
      record.
    </Typography>
    <ul>
      <li>
        <Typography>
          <AddIcon className={classes.icon} />
          <strong> ADD: </strong>Add new Note Line Item.
        </Typography>
      </li>
      <li>
        <Typography>
          <RemoveIcon className={classes.icon} />
          <strong> REMOVE: </strong>
          Remove selected Note Line Item - this info will be permanently lost.
        </Typography>
      </li>
    </ul>
  </>
);

export const OutboundSetupHelpEdit = ({ classes, bolData }) => (
  <>
    <Typography variant="overline">
      <strong>Outbound Setup</strong>
    </Typography>
    <ul>
      <li>
        <Typography>
          <strong>PO Number: </strong>
          Purchase Order number provided by Customer.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Carrier Name: </strong>
          Rail line / truck line name.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Carrier Type: </strong>
          Select carrier type - determines "Pickup Number" or "Railcar Number".
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Pickup Number: </strong> Required if Carrier Type = "Truck".
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Railcar Number: </strong>
          Required if shipping by Rail and Carrier Type = "Rail".
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Must Tarp: </strong>
          Required if Carrier Type = "Truck". Indicate if load needs to be
          covered with tarp.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Destination Name & Address: </strong>
          Optional - can be left blank for "Blind Shipments". If Destination
          entered, address is required.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>PO File: </strong>
          Attach the original PO from customer.
        </Typography>
      </li>
      <li>
        <Typography variant="overline">
          <strong>Custom Fields</strong>
        </Typography>
        <Typography>
          User-defined in Account setup. These fields are Account-specific, so
          they may differ from one inbound to another.
        </Typography>
      </li>
      <li>
        <Typography>
          <InvoiceIcon className={classes.icon} />
          <strong> INVOICE: </strong>Generate new Invoice for this Outbound
          Shipment.
        </Typography>
      </li>
      <li>
        <Typography>
          <DocumentIcon className={classes.icon} />
          <strong> CREATE BOL: </strong>
          Generate Bill of Lading as a downloadable, editable .DOCX document.
          Custom BOL template can up uploaded in Account settings.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>BOL Data: </strong>
        </Typography>
        <DocData obj={bolData} />
      </li>
    </ul>
  </>
);
export const OutboundPickListHelpEdit = ({ classes }) => (
  <>
    <Typography variant="overline">
      <strong>Pick List</strong>
    </Typography>
    <ul>
      <li>
        <Typography>
          <strong>Product Name: </strong>
          Product name as displayed in the Inventories. Items linked to Product
          Catalog will have an <InfoOutlinedIcon
            className={classes.icon}
          />{" "}
          Info Bubble in the right corner. Those not linked to a Product, will
          display <LinkOffIcon className={classes.icon} /> broken link icon.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Qty. On Hand: </strong>Stock quantity in storage.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Qty. Committed: </strong>
          Stock quantity Reserved across all Outbound Shipments, including this
          one - dynamically updated.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Qty. Available: </strong>
          Stock quantity available of Outbound Shipment, inclusive of Qty.
          Committed in this shipment.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Qty. Outbound: </strong>Stock quantity Reserved for this
          shipment.
        </Typography>
      </li>
      <li>
        <Typography variant="overline">
          <strong>Custom Fields</strong>
        </Typography>
        <Typography>
          User-defined in Account setup or Product Catalog. These fields are
          Account- and Product-specific, so they may differ from one inbound to
          another.
        </Typography>
      </li>
      <li>
        <Typography>
          <AddIcon className={classes.icon} />
          <strong> ADD: </strong>
          Add new Line Item to Pick List. Launches "Inventory Search" dialog.
          Account must be selected on Shipment Setup Tab to enable the Add
          button. Inventory Search dialog allows you to search for All
          Inventories by hitting the Search button, or narrowing down results by
          product name, or lot number.
        </Typography>
      </li>
      <li>
        <Typography>
          <RemoveIcon className={classes.icon} />
          <strong> REMOVE: </strong>
          Remove selected Pick List Line Item and adjust global Inventory
          counts.
        </Typography>
      </li>
      <li>
        <Typography>
          <EditIcon className={classes.icon} />
          <strong> EDIT: </strong>
          Edit Qty. Outbound of selected Line Item. After saving or cancelling
          changes, you will be brought back to this screen.
        </Typography>
      </li>
      <li>
        <Typography gutterBottom>
          <strong>Total Quantity & Shipping Units: </strong>
          Sum total of Qty. Outbound. Indicate units of measure for counting Qty
          shipped.
        </Typography>
      </li>
      <li>
        <Typography gutterBottom>
          <strong>Bill Quantity & Units: </strong>
          Total Qty. Outbound and Units used for invoicing customer. If Billing
          Units = Weight Units, the measured truck weight will be used for
          invoicing.
        </Typography>
      </li>
    </ul>
  </>
);
export const OutboundDispatchHelpEdit = ({ classes }) => (
  <>
    <Typography variant="overline">
      <strong>Dispatch</strong>
    </Typography>
    <Typography variant="subtitle1">
      Use the Dispatch Tab to capture key event timestamps when the shipment is
      advanced from Pending {">"} Placed {">"} Released status. Alternatively,
      you can advance a record directly from the "Outboud Shipment" List view.
    </Typography>
    <ul>
      <li>
        <Typography>
          <strong>Date Created: </strong>
          Date customer advised of Outbound Shipment.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Time Arrived: </strong>
          When the driver arrived at the yard — stamped automatically by the
          driver gate check-in, or entered manually.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Time Placed: </strong>
          When the load was placed (spotted) and ready to work.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Empty Weight & Units: </strong>
          Empty truck weight at time of Arrival. Used for invoicing if Units =
          Billing Units.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Load Start Time:</strong> Time when Crew started loading
          outbound inventory.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Load End Time:</strong> Time when Crew finished loading
          outbound inventory.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Time Released:</strong> Time shipment was approved and
          Released.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Loaded Weight & Units: </strong>
          Loaded truck weight at time of Departure. Used for invoicing if Units
          = Billing Units.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Seal Number: </strong>
          Seal tag number for shipments that require sealing.
        </Typography>
      </li>
    </ul>
  </>
);
export const OutboundNotesHelpEdit = ({ classes }) => (
  <>
    <Typography variant="overline">
      <strong>Notes</strong>
    </Typography>
    <Typography variant="subtitle1">
      Use the Notes Tab to document key events and changes made to the Shipment
      record.
    </Typography>
    <ul>
      <li>
        <Typography>
          <AddIcon className={classes.icon} />
          <strong> ADD: </strong>Add new Note Line Item.
        </Typography>
      </li>
      <li>
        <Typography>
          <RemoveIcon className={classes.icon} />
          <strong> REMOVE: </strong>
          Remove selected Note Line Item - this info will be permanently lost.
        </Typography>
      </li>
    </ul>
  </>
);
export const OutboundHistoryHelpEdit = ({ classes }) => (
  <>
    <Typography variant="overline">
      <strong>History</strong>
    </Typography>
    <Typography variant="subtitle1">
      The History Tab provides an automated, chronological Audit Trail of key
      events and record changes.
    </Typography>
  </>
);
